import { apiSlice } from './apiSlice';

export const projectsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProjects: builder.query<any, any>({
      query: ({ perPage, ...params } = {}) => ({ url: '/projects', params: { ...params, ...(perPage !== undefined ? { limit: perPage } : {}) } }),
      providesTags: ['Project'],
    }),
    getProject: builder.query<any, string | number>({
      query: (id) => ({ url: `/projects/${id}` }),
      providesTags: (_result, _err, id) => [{ type: 'Project', id }],
    }),
    deleteProject: builder.mutation<any, string | number>({
      query: (id) => ({ url: `/projects/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Project'],
    }),
  }),
});

export const { useGetProjectsQuery, useGetProjectQuery, useDeleteProjectMutation } = projectsApi;
export default projectsApi;
